
// 赠送相关，而又不是在show页面展示的路由
// 主要是微站活动页面
import {loadPageFail} from '../lib/units';

export default [
    {
        name: '20inPromotion',
        path: '/20inPromotion',
        meta: {
            title: '双11年度狂欢大促',
            keepAlive: true , // 此组件需要被缓存
            fullTitle:function(){
               return '双11年度狂欢大促';
            }
        },
        component: resolve => require(['../pages/show/20DoubleEleven/index.vue'], resolve, (err)=>{
            loadPageFail({
                pagename: '双11年度狂欢大促',
                err
            });
        })
    },
    {
        name: '20rankingList',
        path: '/20rankingList',
        meta: {
            title: '人气测评排行榜',
            fullTitle:function(){
                return '人气测评排行榜';
            }
        },
        component: resolve => require(['../pages/show/20DoubleEleven/rankingList.vue'], resolve, (err)=>{
            loadPageFail({
                pagename: '人气测评排行榜',
                err
            });
        })
    },
    {
        name: 'inPromotion',
        path: '/inPromotion',
        meta: {
            title: '双11年度狂欢大促',
            fullTitle:function(){
                return '双11年度狂欢大促';
            }
        },
        component: resolve => require(['../pages/show/inPromotion.vue'], resolve, (err)=>{
            loadPageFail({
                pagename: '双11年度狂欢大促',
                err
            });
        })
    },
    {
        name: 'depositSucceed',
        path: '/depositSucceed',
        meta: {
            title: '定金预付成功',
            fullTitle:function(){
                return '定金预付成功';
            }
        },
        component: resolve => require(['../pages/show/promotion/depositSucceed.vue'], resolve, (err)=>{
            loadPageFail({
                pagename: '定金预付成功',
                err
            });
        })
    },
    {
        name: 'couponReceive',
        path: '/couponReceive/:channelId/:uuid',
        meta: {
            title: '领取好友优惠券'
        },
        component: resolve => require(['../pages/show/couponShare/couponReceive.vue'], resolve, (err)=>{
            loadPageFail({
                pagename: '领取好友优惠券',
                err
            });
        })
    },
    {
        name: 'couponShare',
        path: '/couponShare',
        meta:{
            title: '赠送好友优惠券',

        },
        component: resolve => require(['../pages/show/couponShare/couponShare.vue'], resolve, (err)=>{
            loadPageFail({
                pagename: '赠送好友优惠券',
                err
            });
        })
    },
    {
        name: 'doubleTwelve',
        path: '/doubleTwelve',
        meta: {
            title: '双十二活动专场',
            fullTitle:function(){
                return '双十二活动专场';
            }
        },
        component: resolve => require(['../pages/show/activity/doubleTwelve.vue'], resolve, (err)=>{
            loadPageFail({
                pagename: '双十二活动专场',
                err
            });
        })
    },
    {
        name: 'doubleDenier',
        path: '/doubleDenier',
        meta: {
            title: '双旦活动专场',
            fullTitle:function(){
                return '双旦活动专场';
            }
        },
        component: resolve => require(['../pages/show/activity/doubleDenier.vue'], resolve, (err)=>{
            loadPageFail({
                pagename: '双旦活动专场',
                err
            });
        })
    },{
        name: 'aosikaShow',
        path: '/aosikaShow',
        meta: {
            title: '奥斯卡活动',
            fullTitle:function(){
                return '奥斯卡活动';
            }
        },
        component: resolve => require(['../pages/show/activity/aosikaShow.vue'], resolve, (err)=>{
            loadPageFail({
                pagename: '奥斯卡活动',
                err
            });
        })
    },
    {
        name: 'vipDetail',
        path: '/vipDetail',
        meta: {
            title: '会员详情页',
        },
        component: resolve => require(['../pages/show/vipDetail'], resolve, (err)=>{
            loadPageFail({
                pagename: '会员详情页',
                err
            });
        })
    },
    {
        name: 'invitation',
        path: '/invitation',
        meta: {
            title: '我的邀请'
        },
        component: resolve => require(['../pages/show/invitation'], resolve, (err)=>{
            loadPageFail({
                pagename: '我的邀请',
                err
            });
        })
    },
    {
        name: 'qixiAnswer',
        path: '/qixiAnswer',
        meta: {
            title: '我在七夕躲避秀恩爱的方式'
        },
        component: resolve => require(['../pages/show/activity/2021Qixi/answer'], resolve, (err)=>{
            loadPageFail({
                pagename: '我在七夕躲避秀恩爱的方式',
                err
            });
        })
    },
    {
        name: 'qixiResult',
        path: '/qixiResult',
        meta: {
            title: '我在七夕躲避秀恩爱的方式'
        },
        component: resolve => require(['../pages/show/activity/2021Qixi/result'], resolve, (err)=>{
            loadPageFail({
                pagename: '我在七夕躲避秀恩爱的方式',
                err
            });
        })
    },
    {
        name: 'vipLottery',
        path: '/vipLottery',
        meta: {
            title: '入会抽奖活动'
        },
        component: resolve => require(['../pages/show/activity/2022vip/lottery'], resolve, (err)=>{
            loadPageFail({
                pagename: '入会抽奖活动',
                err
            });
        }),
        redirect: '/vipLotteryV2'
    },
    {
        name: 'lotteryRecord',
        path: '/lotteryRecord',
        meta: {
            title: '抽奖记录'
        },
        component: resolve => require(['../pages/show/activity/2022vip/record'], resolve, (err)=>{
            loadPageFail({
                pagename: '抽奖记录',
                err
            });
        }),
        redirect: '/lotteryRecordV2'
    },
  {
    name: 'vip3-rights',
    path: '/vip3Rights',
    meta: {
      title: '会员权益'
    },
    component: resolve => require(['../pages/show/activity/2022vip/rights'], resolve, (err)=>{
      loadPageFail({
        pagename: '会员权益',
        err
      });
    })
  },
  {
    name: 'union-vip3-success',
    path: '/unionVip3Success',
    meta: {
      title: '领取成功'
    },
    component: resolve => require(['../pages/show/activity/2022vip/unionVipSuccess'], resolve, (err)=>{
      loadPageFail({
        pagename: '领取成功',
        err
      });
    })
  },
  {
    name: 'vip3-detail',
    path: '/vip3Detail',
    meta: {
      title: '会员详情页'
    },
    component: resolve => require(['../pages/show/activity/2022vip/detail'], resolve, (err)=>{
      loadPageFail({
        pagename: '会员详情页',
        err
      });
    })
  },
  //   4.0会员
  {
    name: 'welcome-vip',
    path: '/welcomeVip',
    meta: {
        title: '欢迎加入测评会员'
    },
    component: resolve => require(['../pages/show/activity/2023vip/welcomeVip'], resolve, (err)=>{
        loadPageFail({
        pagename: '欢迎加入测评会员',
        err
        });
    })
  },
  {
    name: 'vip4-rights',
    path: '/vip4Rights',
    meta: {
        title: '会员权益'
    },
    component: resolve => require(['../pages/show/activity/2023vip/rights'], resolve, (err)=>{
        loadPageFail({
            pagename: '会员权益',
            err
        });
    })
  },
  // 拉新活动
  {
    name: 'inviteHelp',
    path: '/inviteHelp',
    meta: {
        title: '邀请好友助力'
    },
    component: resolve => require(['../pages/show/activity/inviteHelp20221201/index.vue'], resolve, (err)=>{
        loadPageFail({
            pagename: '邀请好友助力',
            err
        });
    })
  },
  {
    name: 'inviteHelpShare',
    path: '/inviteHelpShare',
    meta: {
        title: '邀请好友'
    },
    component: resolve => require(['../pages/show/activity/inviteHelp20221201/share.vue'], resolve, (err)=>{
        loadPageFail({
            pagename: '邀请好友',
            err
        });
    })
  },
  {
    name: 'vipLotteryV2',
    path: '/vipLotteryV2',
    meta: {
        title: '入会抽奖活动'
    },
    component: resolve => require(['../pages/show/activity/inviteHelp20221201/lottery'], resolve, (err)=>{
        loadPageFail({
            pagename: '入会抽奖活动',
            err
        });
    })
  },
  {
    name: 'lotteryRecordV2',
    path: '/lotteryRecordV2',
    meta: {
        title: '抽奖记录'
    },
    component: resolve => require(['../pages/show/activity/inviteHelp20221201/record'], resolve, (err)=>{
        loadPageFail({
            pagename: '抽奖记录',
            err
        });
    })
  },
  {
    name: 'portrait',
    path: '/portrait',
    meta: {
        title: '我的心理画像'
    },
    component: resolve => require(['../pages/show/portrait'], resolve, (err)=>{
        loadPageFail({
            pagename: '我的心理画像',
            err
        });
    })
  }
]



// WEBPACK FOOTER //
// ./src/router/activity.js